(function () {
  if (window.__cartUpsellBound) return;
  window.__cartUpsellBound = true;

  // STEP 1: Queue to prevent race conditions from fast clicks
  window.__cartUpsellQueue = window.__cartUpsellQueue || Promise.resolve();

  function enqueue(task) {
    window.__cartUpsellQueue = window.__cartUpsellQueue
      .then(task)
      .catch((e) => console.error('Upsell queue error:', e));
    return window.__cartUpsellQueue;
  }

  async function refreshCartDrawer() {
    const res = await fetch('/?sections=cart-drawer', { credentials: 'same-origin' });
    const sections = await res.json().catch(() => ({}));
    const html = sections && sections['cart-drawer'];
    if (!html) return;

    const temp = document.createElement('div');
    temp.innerHTML = html;

    const newInner = temp.querySelector('.drawer__inner');
    const currentInner = document.querySelector('.drawer__inner');

    if (newInner && currentInner) {
      currentInner.replaceWith(newInner);
    }
  }

  async function addVariant(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw new Error(data.description || data.message || 'Add failed');
    }
    return data;
  }

  // STEP 2: Fix "back from checkout shows empty cart" (BFCache + back/forward navigation)
  window.addEventListener('pageshow', function (event) {
    try {
      const nav = performance.getEntriesByType('navigation')[0];
      const isBackForward = nav && nav.type === 'back_forward';

      if (event.persisted || isBackForward) {
        refreshCartDrawer().catch(console.error);
      }
    } catch (e) {
      // If browser doesn't support navigation entries, fail safely
      if (event.persisted) refreshCartDrawer().catch(console.error);
    }
  });

  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('.cart-upsell-add-btn');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      if (btn.disabled) return;

      const variantId = btn.dataset.variantId; // from data-variant-id
      if (!variantId) return;

      const original = btn.textContent;
      btn.textContent = '...';
      btn.disabled = true;

      enqueue(async () => {
        await addVariant(variantId);
        await refreshCartDrawer();
      })
        .catch((err) => {
          console.error('Upsell error:', err);
        })
        .finally(() => {
          // The cart drawer may have been re-rendered; only touch the button if it's still in DOM
          if (btn && btn.isConnected) {
            btn.textContent = original;
            btn.disabled = false;
          }
        });
    },
    true
  );
})();